// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"ColumnImages_tableHeader__BIRbz","tableBody":"ColumnImages_tableBody__q_660"};